module.exports = __webpack_public_path__ + "img/Thushen Mohanarajah.b0eaabbe.jpg";